export default __webpack_public_path__ + "static/media/sliderMobile_1.d2ee42f8.jpg";